import { createContext, useContext } from 'react'

/**
 * Where a game's key legend is drawn.
 *
 * On a phone or a laptop it is drawn where it is written — at the bottom of
 * the game's own column. On the television it belongs to the screen rather
 * than to the game: full width, along the bottom, in the same place whichever
 * game is running, because a map that moves depending on how tall the game
 * happens to be is one you have to find again each time.
 *
 * A slot in the layout rather than `position: fixed` with a reserved height.
 * That was the first attempt and it had the fault the whole approach invites:
 * the height was a constant, Small Rabbit's Scramble has six shortcuts, they
 * wrapped to two rows, and the second row was drawn below the bottom of the
 * screen where no amount of scrolling could reach it. A slot takes exactly the
 * room its contents need, and the game gets the rest — which is also what
 * makes "fill the height" possible for the games that want it.
 */
export const LegendSlotContext = createContext<HTMLElement | null>(null)

export function useLegendSlot(): HTMLElement | null {
  return useContext(LegendSlotContext)
}
